<template>
  <div class="flex justify-center w-full overflow-hidden mt-2">
    <ul class="flex pl-0 list-none rounded my-2 select-none">
      <li
        class="flex justify-center items-center pointer w-9 h-9 stroke-blue-700"
        v-if="currentPage > 2"
        @click="gotoPageNumber(--currentPage)"
      >
        <IconArrowDown class="-rotate-90" />
      </li>

      <li
        class="flex justify-center items-center pointer border border-blue-500 rounded-xl w-9 h-9"
        v-for="pageNumber in displayedPages"
        @click="gotoPageNumber(pageNumber)"
        :key="pageNumber"
        :class="[
          currentPage === pageNumber
            ? 'bg-blue-400 text-[#b9c2df]'
            : 'bg-white text-blue-350',
          pageNumber === 1
            ? 'ml-1'
            : pageNumber === totalPages
            ? 'mr-1'
            : 'mx-1',
        ]"
      >
        {{ pageNumber }}
      </li>

      <li
        class="flex justify-center items-center pointer w-9 h-9 stroke-blue-700"
        v-if="currentPage < totalPages - 1"
        @click="gotoPageNumber(++currentPage)"
      >
        <IconArrowDown class="rotate-90" />
      </li>
    </ul>
  </div>
</template>

<script setup>
const props = defineProps({
  currentPage: Number,
  totalPages: Number,
  type: String,
});

const emit = defineEmits("pagechanged");

const pages = computed(() => {
  const range = [];
  for (let i = 1; i <= props.totalPages; i++) {
    range.push(i);
  }
  return range;
});

const showMore = computed(() => {
  return props.totalPages > 7;
});

const displayedPages = computed(() => {
  const currentPage = props.currentPage;
  const totalPages = pages.value.length;

  if (totalPages <= 3) {
    return pages.value;
  } else if (currentPage == 1) {
    return [1, 2, 3];
  } else if (currentPage == totalPages) {
    return [totalPages - 2, totalPages - 1, totalPages];
  } else {
    return [currentPage - 1, currentPage, currentPage + 1];
  }
});

const gotoPageNumber = (page) => {
  emit("pagechanged", page, props.type);
};
</script>
